import React from 'react';
import Widget from 'components/Widget/index';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import WidgetRainbow from 'components/kea/widgets/common/WidgetRainbow';
import { analyticsChartTheme } from 'util/chartUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const DiscoveryWidget = ({ stats }) => {
  const localizeMessage = useLocalizedMessage();
  if (!stats) {
    return (
      <Widget styleName="jr-card-full noMargin">
        <PlaceholderSpinner height={129} />
      </Widget>
    );
  }

  const totalViews = Number(stats.totalViews) || 0;
  const fromRecsViews = Number(stats.fromRecsViews) || 0;
  const fromSearchViews = Number(stats.fromSearchViews) || 0;
  const otherViews = Math.max(totalViews - fromRecsViews - fromSearchViews, 0);

  const pieData = [
    {
      id: '1',
      name: localizeMessage('analytics.product.discovery.recommendations'),
      fill: analyticsChartTheme.clickEvents,
      value: fromRecsViews,
    },
    {
      id: '2',
      name: localizeMessage('analytics.product.discovery.search'),
      fill: analyticsChartTheme.searches,
      value: fromSearchViews,
    },
    {
      id: '3',
      name: localizeMessage('analytics.product.discovery.other'),
      fill: analyticsChartTheme.previous,
      value: otherViews,
    },
  ];

  return (
    <WidgetRainbow
      pieData={pieData}
      title={localizeMessage('analytics.product.discovery.title')}
      mainNumber={totalViews}
      description={localizeMessage('analytics.product.discovery.description')}
      tone="clickEvents"
    />
  );
};

export default DiscoveryWidget;
